import { render } from "./Barishal.vue?vue&type=template&id=76e6cabe"
import script from "./Barishal.vue?vue&type=script&lang=js"
export * from "./Barishal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__